/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.footer", {
        options: {},

        _create() {
            this.wrap = this.element;

            $(".footer__title", this.wrap).on("click", (e) => {
                e.preventDefault();

                var hdncont = $(e.target).parent().find(".footer__main__extra");

                $(e.target).parent().toggleClass("active");

                if ($(window).width() <= 970) {
                    hdncont.slideToggle();
                }
            });

            $(window).on("resize", () => {
                if ($(window).width() > 970) {
                    $(".footer__main__col", this.wrap).removeClass("active");
                    $(".footer__main__extra", this.wrap).removeAttr("style");
                }
            });
        },
    });
})(jQuery);
